module.exports = __webpack_public_path__ + "img/about-2.a4fac561.png";